// Utility to get the correct API URL based on environment
// Uses relative path in production (same domain), full URL in preview/development

export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // If we're on the production domain, use relative URLs
    if (hostname.includes('justasmile-events.com') || hostname.includes('app.justasmile')) {
      return '';  // Relative path - API is on same domain
    }
  }
  // Otherwise use the configured backend URL (for preview/development)
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();

export default API_URL;
